import React, {
  memo, useEffect, useMemo, useState,
} from 'react'
import Image from 'next/image'
import clsx from 'clsx'
import IconChecked from 'components/icons/IconChecked.svg'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { mapType } from 'utils/miscellaneous'
import { toggleValueFromString } from 'utils/universal'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import EventEmitter from 'services/EventEmitter'
import sx from './styles'

const BodyTypes = ({
  items = [],
  bodiesSelected = '',
  onChange,
}) => {
  const [isAllSelected, setIsAllSelected] = useState(false)
  const { bodies } = useMemo(() => mapType(items), [items])
  const allItems = bodies.map((item) => item.name).join('_')

  const handleItemToggle = (item) => {
    if (isAllSelected) {
      setIsAllSelected(false)
    }
    const formattedName = toggleValueFromString(bodiesSelected, item.name)
    if (allItems?.split('_')?.length === formattedName?.split('_')?.length) {
      setIsAllSelected(true)
      onChange(({ body: `${formattedName}_desconocido_mm_familiar (es)` }))
    } else {
      onChange(({ body: formattedName }))
    }
  }

  const handleAllSelected = () => {
    setIsAllSelected((prev) => !prev)
    if (!isAllSelected) {
      onChange(({ body: `${allItems}_desconocido_mm_familiar (es)` }))
    }
    if (isAllSelected) {
      onChange(({ body: '' }))
    }
  }

  const handleReset = () => {
    onChange(({ body: '' }))
    setIsAllSelected(false)
  }

  useEffect(() => {
    EventEmitter.suscribe('resetBodies', handleReset)
    return () => {
      EventEmitter.unsubscribe('resetBodies')
    }
  }, [])

  return (
    <Grid
      container
      sx={sx.root}
    >
      {bodies
        && bodies
          ?.sort((a, b) => a.position - b.position)
          ?.map((body, index) => (
            <Grid
              size={3} // Cada item ocupa 3 columnas
              key={`body-${index}`}
              sx={sx.item}
              className={clsx({
                selected: bodiesSelected?.includes(body.name),
              })}
              onClick={() => handleItemToggle(body)}
            >
              <Box
                sx={sx.button}
                className={clsx({
                  selected: bodiesSelected?.includes(body.name),
                })}
              >
                {bodiesSelected?.includes(body.name) || isAllSelected ? (
                  <IconChecked />
                ) : (
                  <Image
                    src={`/img/types/find-a-car/${body.icon}.png`}
                    alt={body.name}
                    title={body.name}
                    width={30}
                    height={12}
                  />
                )}

              </Box>
              <Typography
                variant="body1"
                noWrap
                sx={sx.itemName}
              >
                {body?.name}
              </Typography>
            </Grid>
          ))}
      <Grid
        size={3} // Cada item ocupa 3 columnas
        key="body-todos"
        sx={sx.item}
        className={clsx({
          selected: isAllSelected,
        })}
        onClick={handleAllSelected}
      >
        <Box sx={sx.button}>
          {isAllSelected ? (
            <IconChecked />
          ) : (
            <DoneAllIcon />
          )}

        </Box>
        <Typography
          variant="body1"
          noWrap
          sx={sx.itemName}
        >
          Todos
        </Typography>
      </Grid>
    </Grid>
  )
}

export default memo(BodyTypes)
